module.exports = __webpack_public_path__ + "img/baoming.07de1137.png";